import React from 'react';

import CollectionTaxonomyLink from './collection-taxonomy-link';

const TaxonomyPanel = (props) => {
  const epochLabels = [
    'Pre-16th Century',
    '16th Century',
    '17th Century',
    '18th Century',
    '19th Century',
    '20th Century',
  ];
  let labels = props.labels;

  // Special case sorting for Epoch links
  if (props.taxon === 'Epoch') {
    labels = epochLabels.filter(label => labels.includes(label));
  }

  return (
    <>
      {(props.labels) ? (
        <div className="collections-taxonomy-bar__panel">
          {labels.map((label, idx) => (
            <CollectionTaxonomyLink
              key={`taxonomy-link-${idx}`}
              mediaGroup={ props.mediaGroup }
              taxon={ props.taxon.toLowerCase() }
              label={ label }
            />
          ))}
        </div>
      ) : null}
    </>
  );
};

export default TaxonomyPanel;